var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "link-2-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s1 { fill: none } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40206",
    className: "s0",
    d: "m21.8 16.6v1.3q0.1 1.1-0.2 2.1-0.4 1.1-1.1 1.8-0.8 0.8-1.8 1.2-1 0.4-2.1 0.4h-9.1q-1.1 0-2.1-0.4-1-0.4-1.7-1.2-0.8-0.7-1.1-1.8-0.4-1-0.3-2.1v-8.5q-0.1-1.1 0.3-2.1 0.3-1.1 1.1-1.8 0.7-0.8 1.7-1.2 1-0.4 2.1-0.4h1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40283",
    className: "s0",
    d: "m21.8 3.9l-11.6 11.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40284",
    className: "s0",
    d: "m14 3.9h7.8v7.8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13905",
    className: "s1",
    d: "m0 0h24v24h-24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/link-2.92ad333f.svg";
export { ForwardRef as ReactComponent };